import WebApiService from "@/services/webapi.service.js";

const state = {
    clienti: null,
    ClientiCount: []
}

const getters = {
    getClienti: (state) =>{
        return state.clienti ?? JSON.parse(localStorage.getItem("clienti"));
    },
    getClientiCount: (state) => (type )=>{
        let v = localStorage.getItem("ClientiCount");
        let clienti = null;
        if(v != null && v[type] != null){
            clienti = JSON.parse(v[type]);
        }
        return state.ClientiCount[type] ?? clienti;
    }
}

const mutations = {
    setClienti: (state, clientiList) =>{
        state.clienti = clientiList;
        localStorage.setItem('clienti',JSON.stringify(state.clienti));
    },

    setClientiCount: (state, count) =>{
        state.ClientiCount[count.type] = count.total;
        localStorage.setItem('ClientiCount',JSON.stringify(state.ClientiCount));
    }
}

const actions = {
    GetClientiApi: ({commit}, data) => {
        let cliType =  data.cliType;
        return WebApiService.get("Anagrafica/Clienti",data.Token, 
            {
                startIndex: data.pagina, 
                offset: data.offset, 
                type: data.cliType, 
                filter : data.filter, 
                cap: data.cap,
                prov: data.provincia,
                city: data.citta,
            }).then(
            (data) =>{
                if(data) {
                    if(data.StatusCode == 401){
                        return false;
                    }else{
                        commit("setClienti", data.data?.Anagrafiche);
                        commit("setClientiCount",{type: cliType, total:data.data?.Total});
                        return true;
                    }
                }else{
                    return false;
                }
            }
        );
    }
}

export default {
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}